import React from 'react'
import PropTypes from 'prop-types'

const Payment = ({ title, isRecurrent, nextBill, price }) => {
  const renderNonRecurrent = () => (
    <p className="text-sm">
      Your <strong>{title}</strong> will end on {nextBill}.
    </p>
  )

  const renderRecurrent = () => (
    <p className="text-sm">
      Your <strong>{title}</strong> will automatically renew on <strong>{nextBill}</strong> and you
      will be billed <strong>{price}</strong>.
    </p>
  )

  return (
    <div className="mb-10">
      <h6 className="text-primary-orange font-bold my-5">
        Enjoy your monthly access to coworking spaces with Passport.
      </h6>
      {isRecurrent ? renderRecurrent() : renderNonRecurrent()}
    </div>
  )
}

Payment.propTypes = {
  title: PropTypes.string.isRequired,
  isRecurrent: PropTypes.bool,
  nextBill: PropTypes.string,
  price: PropTypes.string.isRequired,
}

export default Payment
